export const FETCH_CARGO_COMPANIES_PENDING = "FETCH_CARGO_COMPANIES_PENDING";
export const FETCH_CARGO_COMPANIES_REJECTED = "FETCH_CARGO_COMPANIES_REJECTED";
export const FETCH_CARGO_COMPANIES_FULFILLED = "FETCH_CARGO_COMPANIES_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/cargoCompanies.js